import React from 'react';
import styled from 'styled-components';
import classNames from 'classnames';

interface DividerProps {
  noMargin?: boolean;
  vertical?: boolean;
  className?: string;
}

export const Divider: React.FC<DividerProps> = ({
  className,
  noMargin,
  vertical,
}) => (
  <div
    className={classNames(
      'bg-grey-200',
      !noMargin && (vertical ? 'mx-4' : 'my-4'),
      vertical ? 'h-full w-px' : 'w-full h-px',
      className,
    )}
  />
);
